import { ApiConfig } from "../../Config/ApiConfig";
import { createPostDataAction } from "./CommonAction";
import {
  SUBSCRIPTION_PAYMENT_LIST,
  SUBSCRIPTION_PAYMENT_APPROVE,
  SUBSCRIPTION_PAYMENT_REJECT,
  OFFLINE_BANK_SETTINGS_GET,
  OFFLINE_BANK_SETTINGS_UPDATE,
} from "../../Constants/SubscriptionPaymentConstants";

export const SubscriptionPaymentListAction = (payload: any) =>
  createPostDataAction(SUBSCRIPTION_PAYMENT_LIST, ApiConfig.SubscriptionPaymentList, payload, false);

export const SubscriptionPaymentApproveAction = (payload: any) =>
  createPostDataAction(
    SUBSCRIPTION_PAYMENT_APPROVE,
    ApiConfig.SubscriptionPaymentApprove,
    payload,
    true,
  );

export const SubscriptionPaymentRejectAction = (payload: any) =>
  createPostDataAction(
    SUBSCRIPTION_PAYMENT_REJECT,
    ApiConfig.SubscriptionPaymentReject,
    payload,
    true,
  );

export const OfflineBankSettingsGetAction = (payload: any) =>
  createPostDataAction(OFFLINE_BANK_SETTINGS_GET, ApiConfig.OfflineBankSettingsGet, payload, false);

export const OfflineBankSettingsUpdateAction = (payload: any) =>
  createPostDataAction(
    OFFLINE_BANK_SETTINGS_UPDATE,
    ApiConfig.OfflineBankSettingsUpdate,
    payload,
    true,
  );
